export const environment = {
    production: true,
    defaultLanguage: "en",
    publicEndpoint: "https://public.api.ellypos.io",
    globalStylesDefaultUrl: "https://cdn.ellypos.io/pay-gateway/default/global-styles.json",
};
